
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punecabfare() {



    const cardData =
    {
        keyword: '  Pune Cab fare',
        heading: 'Mauli Cabs:  Pune Cab fare',
        headingDescription: 'Mauli Cabs offers affordable and transparent Pune cab fare options, ensuring a budget-friendly and comfortable travel experience across the city and to outstation destinations. Whether you need a cab for local travel, airport transfers, or long-distance journeys, we provide a wide range of vehicles including sedans, SUVs, and premium cars. With professional drivers, no hidden charges, and clear pricing, Mauli Cabs guarantees a smooth, reliable, and cost-effective cab service for all your travel needs in Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historical fortification and the seat of the Peshwa rulers of the Maratha Empire. It is famous for its architectural grandeur and rich history, with beautiful gardens and stunning views of the surrounding area."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace is an elegant historical building, known for its beautiful Italian arches and serene surroundings. The palace has significant historical importance as it was used as a prison for freedom fighters during the British colonial era."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Sinhagad Fort is a popular historic fort located on the outskirts of Pune, offering panoramic views of the surrounding hills and valleys. It is known for its scenic trekking routes and its importance in Maratha history."
    },
    {
        "title": "Osho Ashram",
        "description": "The Osho Ashram, also known as the Osho International Meditation Resort, is a peaceful sanctuary located in Koregaon Park. It offers a variety of meditation programs and wellness treatments, attracting spiritual seekers from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "The Pune Okayama Friendship Garden, also known as the Pu La Deshpande Garden, is a Japanese-style garden located in the heart of the city. It features lush greenery, serene ponds, and beautiful walking paths, perfect for a peaceful stroll."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Located in the city center, this historical monument offers a glimpse into Pune's rich religious and architectural heritage."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Raja Dinkar Kelkar Museum is a fascinating museum showcasing a vast collection of artifacts, including sculptures, paintings, and textiles, reflecting the rich cultural heritage of India."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam is located on the outskirts of Pune and is a popular spot for picnics and relaxation. The dam offers scenic views of the water and surrounding hills, making it an ideal place for a peaceful day out."
    },
    {
        "title": "Fergusson College",
        "description": "Fergusson College is one of the oldest and most prestigious educational institutions in India. The college campus is known for its beautiful colonial architecture, serene environment, and historical significance."
    },
    {
        "title": "Bund Garden",
        "description": "Bund Garden is a well-maintained park located along the Mula-Mutha River. It is a popular spot for jogging, picnics, and boat rides, offering beautiful views of the river and surrounding greenery."
    }
],

"services": [
    {
      "name": "Pune Cab Fare",
      "description": "Get the most affordable and competitive cab fares in Pune. Our rates are transparent and designed to ensure a hassle-free experience. Whether you need a cab for a short or long journey, our pricing is based on distance, vehicle type, and duration."
    },
    {
      "name": "Pune Taxi Rates",
      "description": "Discover the taxi rates for various routes in Pune. Our rates are designed to offer both comfort and affordability for every type of traveler, ensuring you get the best value for your ride."
    },
    {
      "name": "Pune Cab Charges",
      "description": "Our Pune cab charges are based on transparent pricing models that ensure no hidden costs. Whether you're going for a short trip or a long journey, you can count on us for competitive charges."
    },
    {
      "name": "Pune Taxi Fare in Affordable Price",
      "description": "We offer the best taxi fares in Pune without compromising on quality. Enjoy affordable taxi rides with great comfort, ensuring that you travel to your destination without burning a hole in your pocket."
    },
    {
      "name": "Pune Cab Pricing",
      "description": "Get an accurate idea of Pune cab pricing based on your requirements. We provide clear and upfront pricing with no hidden costs, giving you peace of mind when you book your ride."
    },
    {
      "name": "Pune Cab Tariff",
      "description": "Explore our affordable Pune cab tariff for all types of taxi services. From budget to luxury rides, our tariff structure is designed to provide you with the best value."
    },
    {
      "name": "Pune Taxi Fare Estimate",
      "description": "Use our taxi fare estimator to calculate the estimated fare for your trip in Pune. Whether you're traveling across the city or to a nearby destination, get an accurate fare estimate before you book."
    },
    {
      "name": "Pune Cab Rate Card",
      "description": "Check out our Pune cab rate card for detailed information about fares, charges, and pricing for different routes and vehicle types. Plan your trip with clarity and transparency."
    },
    {
      "name": "Pune to Shirdi Cab Fare",
      "description": "Calculate the fare for a taxi ride from Pune to Shirdi. Our pricing is transparent, based on distance and vehicle type, ensuring you get the best deal for your journey."
    },
    {
      "name": "Pune to Shirdi Taxi Fare",
      "description": "Travel from Pune to Shirdi with an affordable taxi fare. Whether you're traveling solo or with a group, we offer competitive fares to make your pilgrimage journey comfortable and budget-friendly."
    },
    {
      "name": "Pune to Mumbai Airport Cab Fare",
      "description": "Know the taxi fare from Pune to Mumbai Airport with our detailed pricing. Our affordable rates ensure a smooth ride from Pune to the airport, allowing you to travel in comfort."
    },
    {
      "name": "Mumbai Pune Taxi Fare",
      "description": "Get the fare for a taxi ride from Mumbai to Pune. With flexible options for one-way or round-trip services, we offer competitive fares that make your journey convenient and affordable."
    },
    {
      "name": "Pune to Mumbai Cab Fare",
      "description": "Our taxi fare from Pune to Mumbai is designed to suit different budgets and preferences. Choose from a range of vehicles and enjoy a comfortable ride between the two cities."
    },
    {
      "name": "Pune to Mumbai Cab Charges",
      "description": "Check the charges for a taxi ride from Pune to Mumbai. We offer competitive pricing for both one-way and round-trip services, ensuring you get value for money."
    },
    {
      "name": "Pune to Bhimashankar Taxi Fare",
      "description": "Calculate the fare for a taxi ride from Pune to Bhimashankar. Our fares are affordable and based on distance, vehicle type, and duration, ensuring that you enjoy a budget-friendly trip."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Fare",
      "description": "Know the taxi fare from Mumbai Airport to Pune. Our taxi services provide reliable and cost-effective options for travelers looking to commute between Mumbai Airport and Pune."
    },
    {
      "name": "Pune Mumbai Taxi Fare",
      "description": "Our taxi fare between Pune and Mumbai is designed to ensure comfort and affordability. We offer different pricing options based on the vehicle and duration of your trip."
    },
    {
      "name": "Pune to Bhimashankar Cab Fare",
      "description": "Our fare for a cab ride from Pune to Bhimashankar is affordable and transparent. Whether you're visiting the famous Bhimashankar temple or exploring the area, our rates are budget-friendly."
    },
    {
      "name": "Pune to Mahabaleshwar Distance by Taxi Fare",
      "description": "Get the fare estimate for a taxi ride from Pune to Mahabaleshwar. Our pricing is based on distance, with clear and upfront charges, making it easy for you to plan your trip."
    },
    {
      "name": "Pune to Goa Taxi Fare",
      "description": "Travel to Goa from Pune with a convenient and affordable taxi fare. Whether you're going for a quick weekend getaway or a long stay, our fares are designed to ensure you get the best value."
    },
    {
      "name": "Pune to Trimbakeshwar Cab Fare",
      "description": "Know the fare for a taxi ride from Pune to Trimbakeshwar temple. Our pricing is based on vehicle type and duration, offering you a smooth and affordable journey."
    },
    {
      "name": "Pune to Aurangabad Taxi Fare",
      "description": "Get the fare estimate for your taxi ride from Pune to Aurangabad. Whether you're traveling for business or leisure, our affordable rates ensure a stress-free journey."
    },
    {
      "name": "Pune Airport to Shirdi Distance Taxi Fare",
      "description": "Find out the taxi fare for traveling from Pune Airport to Shirdi. We offer competitive rates to ensure that you enjoy a comfortable and budget-friendly trip to the holy town."
    },
    {
      "name": "Pune to Mumbai Taxi Price",
      "description": "Know the pricing for your taxi ride from Pune to Mumbai. With competitive rates and reliable service, we ensure that you get to your destination in comfort and on time."
    }
  ],
  "tableData": [
    ["Pune Cab Fare", "Pune Taxi Rates"],
    ["Pune Cab Charges", "Pune Taxi Fare in Affordable Price"],
    ["Pune Cab Pricing", "Pune Cab Tariff"],
    ["Pune Taxi Fare Estimate", "Pune Cab Rate Card"],
    ["Pune to Shirdi Cab Fare", "Pune to Shirdi Taxi Fare"],
    ["Pune to Mumbai Airport Cab Fare", "Mumbai Pune Taxi Fare"],
    ["Pune to Mumbai Cab Fare", "Pune to Mumbai Cab Charges"],
    ["Pune to Bhimashankar Taxi Fare", "Mumbai Airport to Pune Taxi Fare"],
    ["Pune Mumbai Taxi Fare", "Pune to Bhimashankar Cab Fare"],
    ["Pune to Mahabaleshwar Distance by Taxi Fare", "Pune to Goa Taxi Fare"],
    ["Pune to Trimbakeshwar Cab Fare", "Pune to Aurangabad Taxi Fare"],
    ["Pune Airport to Shirdi Distance Taxi Fare", "Pune to Mumbai Taxi Price"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "At Mauli Cabs, we provide affordable and transparent pricing for all our Pune cab services. We offer upfront quotes with no hidden charges, ensuring that you know exactly what you're paying for. Our pricing is competitive, offering great value for the quality of service we provide."
    },
    {
        "WhyChooseheading": "Various Cab Options to Suit Your Budget",
        "WhyChoosedescription": "Whether you're looking for an economical ride or a premium experience, Mauli Cabs offers a wide range of vehicles to suit your budget. From budget-friendly sedans to luxurious SUVs, we have options for all types of travel, ensuring that you can choose a vehicle that matches both your preferences and budget."
    },
    {
        "WhyChooseheading": "Accurate Fare Estimation",
        "WhyChoosedescription": "With Mauli Cabs, you can get an accurate fare estimate before you book your ride. Our website and mobile app provide an easy-to-use fare calculator that helps you plan your trip and know the cost beforehand, making your booking experience hassle-free."
    },
    {
        "WhyChooseheading": "No Hidden Charges",
        "WhyChoosedescription": "We believe in complete transparency. Our Pune cab fare includes everything—taxes, fuel charges, and tolls—so you won’t have to worry about hidden fees popping up after your ride. The fare you see is the fare you pay."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Mauli Cabs offers flexible payment options to make your ride convenient. You can pay for your Pune cab ride using cash, card, or through our mobile app, making the payment process seamless and easy for you."
    },
    {
        "WhyChooseheading": "Affordable Fares for Long-Distance Trips",
        "WhyChoosedescription": "Whether you're booking a short ride within Pune or a long-distance trip outside the city, Mauli Cabs offers affordable fares for both types of journeys. We provide competitive pricing for longer trips, ensuring that your travel remains budget-friendly while enjoying the comfort and safety of our services."
    },
    {
        "WhyChooseheading": "Comfort and Value for Money",
        "WhyChoosedescription": "Mauli Cabs is committed to providing comfort along with great value. Our well-maintained vehicles, professional drivers, and transparent pricing ensure that you get an excellent experience at a price that suits your budget."
    },
    {
        "WhyChooseheading": "Customized Packages and Discounts",
        "WhyChoosedescription": "We offer customized travel packages for various destinations from Pune, and special discounts on frequent or long-distance bookings. Whether you're a business traveler or a tourist, we have fare options that can be tailored to meet your specific needs."
    }
]

























    }


    const faqData = [
        {
            question: 'What is the fare for a cab in Pune with Mauli Cabs?',
            answer: 'The fare for a cab in Pune depends on the type of vehicle and the distance of your journey. We offer competitive pricing for Sedans, SUVs, Ertiga, Innova Crysta, and premium vehicles. You can check the exact fare for your desired trip using our website or mobile app. All fares are transparent and include taxes, tolls, and driver charges.',
        },
        {
            question: 'Is the cab fare in Pune fixed?',
            answer: 'Yes, our fares are fixed and transparent. You’ll know the exact fare upfront before booking, and there are no hidden charges. The fare includes all applicable taxes, tolls, and driver charges.',
        },
        {
            question: 'Does Mauli Cabs offer any discounts or promotions on cab fares in Pune?',
            answer: 'Yes, we offer special discounts and promotions from time to time. Keep an eye on our website or mobile app for ongoing offers, or contact our customer support team to learn about any available discounts.',
        },
        {
            question: 'Are there any additional charges for cabs in Pune?',
            answer: 'The fare you see at the time of booking includes all charges such as taxes, tolls, and driver fees. However, additional charges may apply if there are extra stops, waiting time, or if the route takes longer due to traffic. You’ll be informed about any extra charges before your journey begins.',
        },
        {
            question: 'Can I book a cab for an hourly rate in Pune?',
            answer: 'Yes, you can book a cab in Pune at an hourly rate for city tours or specific time slots. Contact us to get more information about hourly rates and to book a cab for your desired duration.',
        },
        {
            question: 'How can I get an estimate of the Pune cab fare?',
            answer: 'You can easily get an estimate of the cab fare for your journey in Pune by using our website or mobile app. Simply input your pickup location and destination, and the app will calculate the estimated fare for you. Alternatively, you can contact our customer support team for assistance.',
        },
        {
            question: 'Are the cabs in Pune air-conditioned?',
            answer: 'Yes, all our cabs in Pune are air-conditioned and well-maintained to ensure a comfortable and pleasant journey.',
        },
        {
            question: 'Can I book a cab in Pune for a round trip?',
            answer: 'Yes, you can easily book a round trip cab in Pune. Just provide your return details during booking, and we’ll ensure that you’re taken care of for both your onward and return journeys.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune cab service?',
            answer: 'Mauli Cabs offers affordable, fixed fares with no hidden charges, a variety of well-maintained vehicles, experienced drivers, and a commitment to customer satisfaction. Whether you need a ride for business, leisure, or sightseeing, we ensure a safe, comfortable, and hassle-free journey.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Patil",
            position: "Commuter",
            text: "I use Mauli Cabs regularly for my trips in and around Pune, and I can say their fares are very reasonable. The service is excellent, and the drivers are courteous and professional. I appreciate the transparency in their pricing and highly recommend their service!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Deshmukh",
            position: "Tourist",
            text: "I booked a cab with Mauli Cabs for a city tour in Pune. The fare was very competitive, and the car was in great condition. I felt very comfortable throughout the trip, and the driver knew all the best spots to visit in the city. Will definitely use Mauli Cabs for my next trip.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune Cab Fare Information",
        "description": "Find affordable and transparent cab fare pricing for various routes in Pune. From local taxi rates to outstation fares, we provide the best pricing for services like Pune to Shirdi, Pune to Mumbai, Pune to Mahabaleshwar, and more. Get instant fare estimates and booking details.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.6",
          "ratingCount": "1520"
        },
        "offers": {
          "@type": "Offer",
          "url": "https://www.example.com/pune-cab-fare",
          "priceCurrency": "INR",
          "price": "500",
          "priceValidUntil": "2025-12-31"
        }
      };
      
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune Cab Fare | Affordable Taxi Rates & Pricing | Mauli Cabs</title>
        <meta
          name="description"
          content="Check affordable Pune cab fare for different routes like Pune to Shirdi, Pune to Mumbai, Pune to Mahabaleshwar, Pune to Goa, and more. Transparent pricing and instant fare estimates available."
        />
        <meta
          name="keywords"
          content="Pune Cab Fare, Pune Taxi Rates, Pune Taxi Charges, Pune Cab Pricing, Pune Taxi Fare Estimate, Pune to Shirdi Taxi Fare, Pune to Mumbai Airport Cab Fare, Pune to Mahabaleshwar Fare, Pune to Goa Taxi Fare, Pune to Trimbakeshwar Fare, Pune to Bhimashankar Fare"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77',  
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', 
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punecabfare;